import { resolve } from 'aurelia';
import { getLogger } from '../common/logging';
import { HttpServiceBase } from './http-service-base';
import { UserSession } from './user-session';
import * as env from '../../config/environment.json';
let log = getLogger('AttachmentService');

export class AttachmentService extends HttpServiceBase {
  session = resolve(UserSession);

  get(referenceId, name) {
    return new Promise((resolve, reject) => {
      this.http.get(`v1/files/attachments?referenceId=${referenceId}&name=${name}`)
        .then(message => {
          if (message.response === '') return null;
          return JSON.parse(message.response);
        })
        .then(data => resolve(data))
        .catch(e => reject(e));
    });
  }

  async validate(referenceId) {
    try {
      const message = await this.http.get(`${env.apiUrl}v1/files/attachments/${referenceId}/validate`);
      const body = JSON.parse(message.response);
      return body;
    } catch (e) {
      // Svarade förut valid: true, vilket släppte igenom inskick med
      // bilagor som aldrig kontrollerades.
      this.handleError(e);
      throw e;
    }
  }

  getAttachmentUrl(attachmentId) {
    return `${env.apiUrl}v1/files/attachments/${attachmentId}?jwt=${this.session.token}`;
  }

  save(attachmentId, description) {
    return new Promise((resolve, reject) => {
      this.http.put(`v1/files/attachments/${attachmentId}`, { description })
        .then(httpMessage => JSON.parse(httpMessage.response))
        .then(data => resolve(data))
        .catch(e => reject(e));
    });
  }

  remove(attachmentId) {
    return this.http.delete(`v1/files/attachments/${attachmentId}`);
  }

  async presign(filename, name, referenceId, contentType, maxSize) {
    const response = await this.http.post(
      'v1/files/attachments/presign',
      { filename, name, referenceId, contentType, maxSize: parseInt(maxSize) || 0 }
    );
    return JSON.parse(response.response);
  }

  uploadToPresignedPost(url, fields, file, onProgress) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      for (const [key, value] of Object.entries(fields)) {
        formData.append(key, value);
      }
      // file must be the last field in the FormData
      formData.append('file', file);

      const xhr = new XMLHttpRequest();
      xhr.open('POST', url, true);

      if (onProgress) {
        xhr.upload.addEventListener('progress', (e) => {
          if (e.lengthComputable) {
            onProgress(e.loaded / e.total);
          }
        });
      }

      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve();
        } else {
          reject(new Error(`Upload failed with status ${xhr.status}`));
        }
      };
      xhr.onerror = () => reject(new Error('Upload failed'));
      xhr.send(formData);
    });
  }

  async confirm(tempKey, name, filename, referenceId, description, index, type, maxPages) {
    const response = await this.http.post(
      'v1/files/attachments/confirm',
      { tempKey, name, filename, referenceId, description, index: parseInt(index) || 0, type, maxPages: parseInt(maxPages) || 0 }
    );
    return JSON.parse(response.response);
  }
}


